import { UsersDBSearchParams } from '@/enitites/user'
import { ComputedRef } from 'vue'

export const userKeys = {
  all: ['users'] as const,
  lists: () => [...userKeys.all, 'list'] as const,
  list: (params: UsersDBSearchParams) => [...userKeys.lists(), params] as const,
  details: () => [...userKeys.all, 'detail'] as const,
  detail: (id: ComputedRef<number | undefined>) => [...userKeys.details(), id] as const,
}
